import axios from 'axios'
import router from '../router/index'
import store from '../store/index'
import authGuard from '@/packages/auth-service/router/guard'

router.beforeEach(authGuard(axios, store))
